export default __webpack_public_path__ + "static/media/3.662bf7c0.jpeg";